import { ref } from 'vue';
import dataMasterRepository from '@/repositories/general/dataMasterRepository';

export function useGenDistrict() {
  const listDistrict = ref([]);

  const getData = async () => {
    try {
      const data = await dataMasterRepository.getDistrict();
      if (data.data.status === 200) {
        listDistrict.value = data.data.data.district.list;
      }
    } catch (error) {
      console.log(error);
    }
  };

  getData();

  return { listDistrict };
}
